@if (batchDeparture$ | async; as batchDeparture) {
  <section class="view-attachments-content" [ngSwitch]="activeTab">
    <ng-container *ngSwitchCase="1">
      <div class="info">
        <div class="info-wrapper">
          <div class="info-item">
            <p class="info-item-title">
              {{
                'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.S10CODE' | translate
              }}
            </p>
            <p class="info-item-text">{{ batchDeparture.s10code || '-' }}</p>
          </div>

          <div class="info-item">
            <p class="info-item-title">
              {{
                'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.RECIPIENT_NAME'
                  | translate
              }}
            </p>
            @if (
              batchDeparture?.recipient_contact_widget_data?.person;
              as recipientPerson
            ) {
              <p class="info-item-text">
                {{ getRecipientName(recipientPerson) }}
              </p>
            }
          </div>

          <div class="info-item">
            <p class="info-item-title">
              {{
                'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.NOTIFICATIONS'
                  | translate
              }}
            </p>
            <p class="info-item-text">
              {{
                (NOTIFICATIONS_MAP.get(batchDeparture.notification)
                  | translate) || '-'
              }}
            </p>
          </div>

          <div class="info-item" *ngIf="batchDeparture.notification === '5'">
            <p class="info-item-title">
              {{
                'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.WHERE_TO_SEND_NOTIFICATION'
                  | translate
              }}
            </p>
            <p class="info-item-text">
              {{
                batchDeparture.addons.email ||
                  batchDeparture.addons.phone ||
                  '-'
              }}
            </p>
          </div>

          <div class="info-item">
            <p class="info-item-title">
              {{
                'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.NOTIFICATION_S10CODE'
                  | translate
              }}
            </p>
            <p class="info-item-text">
              {{ batchDeparture.notification_s10code || '-' }}
            </p>
          </div>

          <div class="info-item">
            <p class="info-item-title">
              {{
                'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.SPECIAL_MARKS'
                  | translate
              }}
            </p>
            <p class="info-item-text">
              <app-special-marks-full
                [addons]="batchDeparture.addons"
              ></app-special-marks-full>
            </p>
          </div>

          <div class="info-item">
            <p class="info-item-title">
              {{
                'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.RECIPIENT_ADDRESS'
                  | translate
              }}
            </p>
            <p class="info-item-text">
              {{
                batchDeparture?.recipient_contact_widget_data?.address
                  ?.full_address || '-'
              }}
            </p>
          </div>

          <div class="info-item">
            <p class="info-item-title">
              {{
                'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.ADDITION_SERVICE_PRICE'
                  | translate
              }}
            </p>
            <p class="info-item-text">
              {{ batchDeparture?.additional_services_price || '-' }}
            </p>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="2">
      <section class="mb-2 view-attachments-content__search-block">
        <label class="form-control mb-0 flex-1">
          <div class="position-relative">
            <button
              type="button"
              class="postfix icon-button"
              [attr.aria-label]="'SEARCH' | translate"
            >
              <div [inlineSVG]="'assets/img/icons/search-icon-4.svg'"></div>
            </button>
            <input
              type="search"
              id="attachments_search"
              name="attachments_search"
              [value]="searchParam"
              (input)="searchAttachments($event)"
              class="pr-5"
              [placeholder]="
                'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.SEARCH_FOR_TITTLE_AND_ARTICLE'
                  | translate
              "
              spellcheck="false"
            />
          </div>
        </label>

        <button
          type="button"
          class="button button--outlined"
          [tooltip]="
            (batchDeparture$ | async)?.partial_receipts_count >= 20
              ? ('BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.MAX_ATTACHMENTS_COUNT'
                | translate)
              : ''
          "
          [disabled]="(batchDeparture$ | async)?.partial_receipts_count >= 20"
          (click)="openAddAttachmentModal()"
        >
          <span
            class="filter-button-icon"
            [inlineSVG]="'assets/img/icons/plus.svg'"
          >
          </span>
          <span class="view-attachments-content__search-block-label">
            {{
              'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_CARD.ADD_ATTACHMENT'
                | translate
            }}
          </span>
        </button>
      </section>

      @if (batchDepartureAttachments$ | async; as batchDepartureAttachments) {
        <ng-container *ngIf="!(isAttachmentLoading$ | async); else spinner">
          @if (batchDepartureAttachments.length) {
            <section class="view-attachments-content__manage-panel">
              <div class="checkbox">
                <input
                  type="checkbox"
                  id="is_all_selected"
                  [ngModel]="isAllAttachmentsSelected"
                  (change)="selectAllCards()"
                />
                <label
                  for="is_all_selected"
                  class="view-attachments-content__select-all"
                >
                  <div class="checkbox__el"></div>
                  <div class="checkbox__desc">
                    <p class="view-batch-content-select-all h5">
                      {{ 'SELECT_ALL' | translate }}
                    </p>
                  </div>
                </label>
              </div>

              <button
                type="button"
                class="filter-button"
                [disabled]="selectedAttachments.length < 1"
                (click)="deleteSelectedAttachments()"
              >
                <fa-icon class="filter-button-icon red" [icon]="faTrashAlt">
                </fa-icon>
                <span class="red">{{ 'DELETE' | translate }}</span>
              </button>
            </section>

            <section class="view-attachments-content-list">
              @for (
                attachment of batchDepartureAttachments;
                track attachment.id
              ) {
                <app-attachment-card
                  (deleteAttachments)="
                    sendDeletingAttachmentsIds.emit([$event])
                  "
                  (changeCardSelected)="selectSingleAttachment($event)"
                  [departureAttachment]="attachment"
                  [isEditable]="true"
                />
              }
            </section>
          }
        </ng-container>
      }

      <ng-template #spinner>
        <section class="text-secondary text-center">
          <div class="spinner-border spinner-border-lg" role="status">
            <span class="sr-only">{{ 'LOADING' | translate }}</span>
          </div>
        </section>
      </ng-template>
    </ng-container>
  </section>
}
